import { render, staticRenderFns } from "./FirstCheckinWelcome.vue?vue&type=template&id=60120c75&scoped=true"
import script from "./FirstCheckinWelcome.vue?vue&type=script&lang=js"
export * from "./FirstCheckinWelcome.vue?vue&type=script&lang=js"
import style0 from "./FirstCheckinWelcome.vue?vue&type=style&index=0&id=60120c75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60120c75",
  null
  
)

export default component.exports